import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { get_cart_Data } from "../../redux/action";
import { useWishlist } from "../../context/wishlistContext";

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const cartData = useSelector((state) => state.cartReducer.cart);
    const { pathname } = useLocation();

    const { isLoggedIn, setIsLoggedIn } = useWishlist();

    useEffect(() => {
        const routesToScrollTop = [
            "/about-us",
            "/contact-us",
            "/faq",
            "/privacy-policy",
            "/terms-conditions",
        ];

        if (routesToScrollTop.includes(pathname)) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [pathname]);

    const getTotalQuantity = useCallback(() => {
        return cartData.reduce((acc, item) => acc + (item.quantity || 0), 0);
    }, [cartData]);

    const [totalQuantity, setTotalQuantity] = useState(0);

    useEffect(() => {
        setTotalQuantity(getTotalQuantity());
    }, [getTotalQuantity]);

    useEffect(() => {
        dispatch(get_cart_Data());
    }, [dispatch]);

    useEffect(() => {
        const loginStatus = localStorage.getItem("isLoggedIn");
        setIsLoggedIn(loginStatus === "true");
    }, [setIsLoggedIn]);

    // Logout function
    const onLogout = () => {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setIsLoggedIn(false);
        navigate("/");
    };

    const onCart = () => {
        const existingItemDetails = JSON.parse(localStorage.getItem("itemDetail")) || [];
        const existingCartItemDetails = JSON.parse(localStorage.getItem("cartItemDetail")) || [];

        if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
            localStorage.removeItem("cartItemDetail");
            localStorage.removeItem("itemDetail");
        }

        localStorage.setItem("priviousUrl", "/cart");
        navigate("/cart");
    };

    const onShop = () => {
        localStorage.setItem("priviousUrl", "/products");
        navigate("/products");
    };

    const onAboutUs = () => {
        localStorage.setItem("priviousUrl", "/about-us");
        navigate("/about-us");
    };

    const onBlog = () => {
        localStorage.setItem("priviousUrl", "/blog");
        navigate("/blog");
    };

    const onContactUs = () => {
        localStorage.setItem("priviousUrl", "/contact-us");
        navigate("/contact-us");
    };

    return (
        <div className="header_main">
            <div className="top_wepper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8"></div>

                        <div className="col-lg-4">
                            <div className="order_tracking_wepper">
                                <ul className="mb-0">
                                    <div className="my_account">
                                        <li className="myaccount_menu">
                                            <span className="header_icon curser-pointer">
                                                <i className="fa-solid fa-user"></i> My Account
                                            </span>
                                        </li>

                                        <div className="top_header_menu">
                                            {!isLoggedIn ? (
                                                <>
                                                    <li className="menu_padding py-2 px-3">
                                                        <Link to="/login">
                                                            <i className="fa-solid fa-user" aria-hidden="true"></i> Login
                                                        </Link>
                                                    </li>
                                                </>
                                            ) : (
                                                <>
                                                    <li className="menu_padding py-2 px-3">
                                                        <Link to="/myprofile" className="d-flex align-items-center">
                                                            <i className="fa-solid fa-user" aria-hidden="true"></i>
                                                            <p className="mb-0">My Profile</p>
                                                        </Link>
                                                    </li>

                                                    <li className="menu_padding py-2 px-3">
                                                        <Link to="/myorder" className="d-flex align-items-center">
                                                            <i className="fa-solid fa-user" aria-hidden="true"></i>
                                                            <p className="mb-0">My Order</p>
                                                        </Link>
                                                    </li>

                                                    <li className="menu_padding py-2 px-3">
                                                        <Link to="/wishlist" className="d-flex align-items-center">
                                                            <i className="fa-solid fa-heart" aria-hidden="true"></i>
                                                            <p className="mb-0">Wishlist</p>
                                                        </Link>
                                                    </li>

                                                    <li className="menu_padding py-2 px-3">
                                                        <span
                                                            onClick={onLogout}
                                                            className="header_icon curser-pointer d-flex align-items-center"
                                                        >
                                                            <i className="fa-solid fa-sign-out"></i>
                                                            <p className="mb-0">Logout</p>
                                                        </span>
                                                    </li>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    <li>
                                        <span
                                            onClick={onCart}
                                            className="header_icon curser-pointer position-relative"
                                        >
                                            <i className="fa-solid fa-cart-shopping" aria-hidden="true"></i> Cart
                                            <span
                                                className="position-absolute translate-middle header_item_count"
                                                aria-label={`Cart contains ${totalQuantity} items`}
                                            >
                                                {totalQuantity || 0}
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <header className="header" id="header">
                <nav className="navbar navbar-light navbar-expand-lg">
                    <div className="container">
                        <Link className="navbar-brand" to="/">
                            <div className="logo">
                                <img
                                    src="../../../images/logo.png"
                                    className="without_hover"
                                    alt="Logo"
                                    width={180}
                                />
                            </div>
                        </Link>

                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            aria-controls="offcanvasNavbar"
                        >
                            <span className="navbar-toggler-icon">
                                <img src="../../../images/nav.svg" alt="Menu" />
                            </span>
                        </button>

                        <div
                            className="offcanvas offcanvas-start"
                            tabIndex="-1"
                            id="offcanvasNavbar"
                            aria-labelledby="offcanvasNavbarLabel"
                        >
                            <div className="offcanvas-header">
                                <div className="logo_offcanavs">
                                    <div className="logo">
                                        <img
                                            src="/images/logo.png"
                                            className="without_hover"
                                            alt="Logo"
                                        />
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className="btn-close text-reset"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="offcanvas-body">
                                <ul className="navbar-nav justify-content-center align-items-center flex-grow-1 mb-0">
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/">
                                            Home
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <span onClick={onShop} className="nav-link">
                                            Shop
                                        </span>
                                    </li>

                                    <li className="nav-item">
                                        <span onClick={onAboutUs} className="nav-link">
                                            About us
                                        </span>
                                    </li>

                                    <li className="nav-item">
                                        <span onClick={onBlog} className="nav-link">
                                            Blog
                                        </span>
                                    </li>

                                    <li className="nav-item">
                                        <span onClick={onContactUs} className="nav-link">
                                            Contact Us
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
        </div>
    );
};

export default Header;